// @ts-nocheck
import React, { FC, forwardRef } from "react";
import { defaultRichTextEditorComponentProps, RichTextEditorHostUrl } from "../../constants/globalVariable";
import { createUseStyles } from "react-jss";
import { getRichTextEditorStyle } from "../../constants/globalFunctions";
import {
  RichTextEditorComponent as SyncfusionRichTextEditorComponent,
  Toolbar,
  Inject,
  Image,
  Resize,
  Link,
  HtmlEditor,
  Count,
  QuickToolbar,
  Table,
  RichTextEditorModel,
  FileManager,
} from "@syncfusion/ej2-react-richtexteditor";
import { RichTextEditorComponentProps } from "../../interface";

const RichTextEditorComponent: FC<RichTextEditorComponentProps & RichTextEditorModel> = forwardRef(
  (props: RichTextEditorComponentProps & RichTextEditorModel, ref) => {
    /******************* 
@Purpose : RichTextEditor Component
@Parameter : RichTextEditorComponentProps
@Author : Techture
 *******************/

    const useStyles = createUseStyles({
      richTextEditorStyle: getRichTextEditorStyle(
        props.toolbarBgColor as string,
        props.iconColor as string,
        props.iconSelectedGradientColor1 as string,
        props.iconSelectedGradientColor2 as string,
        props.iconHoverBgColor as string,
        props.iconHoverColor as string,
        props.readonly as any,
        props.contentHeight as string,
        props.padding as any,
      ),
    });

    const fileManagerSettings = () => {
      return {
        enable: true,
        path: "/Pictures/Food",
        ajaxSettings: {
          url: RichTextEditorHostUrl + "api/FileManager/FileOperations",
          getImageUrl: RichTextEditorHostUrl + "api/FileManager/GetImage",
          uploadUrl: RichTextEditorHostUrl + "api/FileManager/Upload",
          downloadUrl: RichTextEditorHostUrl + "api/FileManager/Download",
        },
      };
    };

    const classes = useStyles() as any;
    const injects = [Resize, Toolbar, Image, Link, HtmlEditor, Count, QuickToolbar, Table, FileManager];
    return (
      <SyncfusionRichTextEditorComponent
        {...props}
        ref={ref}
        fileManagerSettings={fileManagerSettings()}
        cssClass={classes.richTextEditorStyle}
      >
        <Inject services={injects} />
      </SyncfusionRichTextEditorComponent>
    );
  },
);
RichTextEditorComponent.defaultProps = defaultRichTextEditorComponentProps;
RichTextEditorComponent.displayName = "RichTextEditorComponent";
export default RichTextEditorComponent;
